import { Transcript } from '@/types/note';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const normalizeString = (value: unknown): string => {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (value === null || value === undefined) {
    return '';
  }

  return String(value).trim();
};

export const normalizeTranscriptEntry = (entry: unknown): Transcript => {
  if (!isRecord(entry)) {
    const text = normalizeString(entry);
    return {
      timecode: 0,
      title: null,
      description: text || null,
      text,
    };
  }

  const title = normalizeString(entry.title);
  const description = normalizeString(entry.description);
  const text = normalizeString(entry.text);

  return {
    ...entry,
    timecode: typeof entry.timecode === 'string' || typeof entry.timecode === 'number' ? entry.timecode : 0,
    title: title || null,
    description: description || text || null,
    text: text || description || title || '',
  };
};

export const normalizeTranscriptEntries = (entries: unknown[]): Transcript[] => entries.map(normalizeTranscriptEntry);

export const getTranscriptTitle = (entry: Transcript): string => normalizeString(entry.title);

export const getTranscriptDescription = (entry: Transcript): string =>
  normalizeString(entry.description) || normalizeString(entry.text) || normalizeString(entry.title);

export const prepareTranscriptEntriesForSave = (entries: Transcript[]): Transcript[] =>
  entries.map((entry) => {
    const description = normalizeString(entry.description ?? entry.text ?? entry.title);

    return {
      ...entry,
      title: null,
      description: description || null,
      text: description || '',
    };
  });
